import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { LOANDEPOT_COPYRIGHT_START_YEAR, LOANDEPOT_NMLS_ID, LOANDEPOT_URLS } from '@ld.consumer-portal/constants';
import { bbbAccreditedBusiness, equalHousingLender } from '@ld.consumer-portal/data-uri';
 
import { BaseModalComponent } from '@ld.consumer-portal/modals';
import { ThemeService } from '@ld.consumer-portal/utils';
@Component({
  selector: 'ld-footer',
  imports: [TranslocoDirective, BaseModalComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  private readonly themeService = inject(ThemeService);
  readonly copyrightStartYear = LOANDEPOT_COPYRIGHT_START_YEAR;
  readonly currentYear = new Date().getFullYear();
  readonly bbbLogo = bbbAccreditedBusiness;
  readonly equalHousingLogo = equalHousingLender;

  protected readonly jvFooter = computed(() => this.themeService.getFooterConfig());
  protected readonly isJvTheme = computed(() => this.themeService.isJvThemeActive());
  protected readonly useLightFooterText = computed(() => this.themeService.useLightFooterText());

  protected readonly privacyAndSecurityUrl = computed(
    () => this.jvFooter()?.privacyUrl ?? LOANDEPOT_URLS.PRIVACY_AND_SECURITY,
  );
  protected readonly termsOfUseUrl = computed(() => this.jvFooter()?.termsOfUseUrl ?? LOANDEPOT_URLS.TERMS_OF_USE);
  protected readonly stateLicensingUrl = computed(
    () => this.jvFooter()?.licensingUrl ?? LOANDEPOT_URLS.STATE_LICENSING,
  );
  protected readonly nmlsConsumerAccessUrl = computed(
    () => this.jvFooter()?.consumerAccessUrl ?? LOANDEPOT_URLS.NMLS_CONSUMER_ACCESS,
  );
  protected readonly nmlsId = computed(() => this.jvFooter()?.nmlsId ?? LOANDEPOT_NMLS_ID);
  protected readonly copyrightText = computed(() => this.jvFooter()?.copyright ?? null);

  protected readonly accessibilityUrl = computed(
    () => this.jvFooter()?.accessibilityUrl ?? LOANDEPOT_URLS.ACCESSIBILITY,
  );
  protected readonly disclaimersUrl = LOANDEPOT_URLS.DISCLAIMERS;
  protected readonly lifetimeGuaranteeUrl = LOANDEPOT_URLS.LIFETIME_GUARANTEE;
  protected readonly cookiePolicyUrl = LOANDEPOT_URLS.COOKIE_POLICY;
  protected readonly txConsumerComplaintUrl = LOANDEPOT_URLS.TX_CONSUMER_COMPLAINT_DISCLOSURE;
  protected readonly ilCommunityReinvestmentUrl = LOANDEPOT_URLS.IL_COMMUNITY_REINVESTMENT_ACT_NOTICE;
  protected readonly txServicingUrl = LOANDEPOT_URLS.TX_SERVICING_DISCLOSURE;
  protected readonly nyServicingUrl = LOANDEPOT_URLS.NY_SERVICING_DISCLOSURE;

  protected readonly showDisclaimersModal = signal(false);

  protected openDisclaimers(): void {
    this.showDisclaimersModal.set(true);
  }

  protected closeDisclaimers(): void {
    this.showDisclaimersModal.set(false);
  }

  protected openCookieSettings(): void {
    const w = window as unknown as Record<string, unknown>;
    const oneTrust = w['OneTrust'] as { ToggleInfoDisplay?: () => void } | undefined;
    if (typeof oneTrust?.ToggleInfoDisplay === 'function') {
      oneTrust.ToggleInfoDisplay();
    }
  }
}
